const s = {
  name: "RussianRuble",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,23v-2h-2v-2h2v-8h5c2.8,0,5,2.2,5,5s-2.2,5-5,5h-3v2h4v2h-4v4h-2v-4h-2v-2H16z M18,19h3c1.7,0,3-1.3,3-3
			c0-1.7-1.3-3-3-3h-3V19z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as RussianRuble
};
